import { createRoute } from "@tanstack/react-router";
import { ConsultantTerritoriesPage } from "@/components/consultants/consultant-territories-page";
import { Route as authenticatedRoute } from "../_authenticated";

function TerritoryPage() {
  const { territory } = Route.useParams();
  // key forces a fresh page (controls reset) when hopping between territories.
  return <ConsultantTerritoriesPage key={territory} territoryKey={territory} />;
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/consultants/territory/$territory",
  component: TerritoryPage,
});
